import { useMutation, useQueryClient } from "@tanstack/react-query";
import { alertService } from "../../../services/alertsService";

export const useDeleteAlert = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ alertId }: { alertId: string }) => {
      const deleted = await alertService.delete(alertId);
      if (!deleted) {
        throw new Error(`Alert with id "${alertId}" not found`);
      }
      return { deleted, alertId };
    },
    onSuccess: ({ alertId }) => {
      qc.invalidateQueries({ queryKey: ["alert", alertId] });
      qc.invalidateQueries({ queryKey: ["alerts"] });
      qc.invalidateQueries({ queryKey: ["alert-events", alertId] });
    },
  });
};
